/* src/components/summary/summary.component.scss */
.content {
  background: var(--background);
  max-height: calc(var(--height) * 0.9);
  overflow-y: auto;
  display: flex;
  padding: 10px;
  width: 100%;
  position: relative;
  flex-direction: column;
}
.content .heading {
  padding: 5px;
}
.content .italics {
  font-style: italic;
}
.content table td,
.content table th {
  padding: 5px;
  border: 1px solid black;
}
/*# sourceMappingURL=summary.component.css.map */
